import React, { useEffect, useState } from 'react';
import userDetailsStyles from "../../../styles/userDetails/userDetails.module.css";
import appointmentStyles from "../../../styles/userDetails/appointmentScheduler.module.css";
import BranchZipcodeClient from "../../../utility/features/api_clients/adminDashboard/branchZipcodeClient.js";


const BranchDetailsModal = ({branchDetails}) => {  
    const {id} = branchDetails;
    const [loading, setLoading] = useState(false);
    const [zipcodes, setZipCodes] = useState([]);

    useEffect(() => {
        setLoading(true);
        const getBranchZipcodes = async () => {
            try {
                const resp = await BranchZipcodeClient(branchDetails.branchID, '');
                if (resp.status === 200) {
                    resp.data
                        ? setZipCodes(resp.data.map(item => ({ postalCodeID: item.postalCodeID, isActive: item.isActive })))
                        : setZipCodes([]);
                }
            } catch (err) {
                console.log("Error fetching branch zipcode details:", err);
                setZipCodes([]);
            }
            setLoading(false);
        };
        if (branchDetails.branchID) getBranchZipcodes();
    }, [branchDetails?.branchID]);
    
    return (

        <div className={`modal fade ${userDetailsStyles["userDetailsModal"]}`} id="BranchDetailsModal" tabIndex="-1" aria-labelledby="BranchDetailsModalLabel" aria-hidden="true">
            <div className={`modal-dialog ${userDetailsStyles["modal-dialog"]}`}>
                <div className={`modal-content ${userDetailsStyles["modal-content"]}`}>
                    <div className={`modal-header ${userDetailsStyles["modal-header"]}`}>
                        <h5 id="BranchDetailsModalLabel" className={`modal-title ${userDetailsStyles["modal-title"]}`}>View Branch Details</h5>
                        <button type="button" className={`btn-close ${userDetailsStyles["btn-close"]}`} data-bs-dismiss="modal" aria-label="Close"
                        />
                    </div>
                    <div className={`modal-body ${userDetailsStyles["modal-body"]}`}>
                        {branchDetails?.branchID && branchDetails?.branchName ? 
                        
                        <>
                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch ID:</span>
                            <span className={appointmentStyles["value"]}>{branchDetails?.branchID || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Branch Name:</span>
                            <span className={appointmentStyles["value"]}>{branchDetails?.branchName || "-"}</span>
                        </div>

                        <div className={appointmentStyles["detailRow"]}>
                            <span className={appointmentStyles["label"]}>Zip Codes:</span>
                            {loading ? (
                                <span className={appointmentStyles["value"]}>Fetching zipcodes...</span>
                            ) : (
                                <span className={appointmentStyles["value"]} style={{ display: 'flex', flexWrap: 'wrap', gap: '6px' }}>
                                    {zipcodes.length > 0 ? (
                                        zipcodes.map((zip, idx) => (
                                            <span
                                                key={zip.postalCodeID + '-' + idx}
                                                style={zip.isActive === false ? { border: '2px solid red', borderRadius: '4px', padding: '2px 6px' } : { padding: '2px 6px' }}
                                            >
                                                {zip.postalCodeID}
                                            </span>
                                        ))
                                    ) : (
                                        `No zipcodes available for ${branchDetails?.branchName} - ${branchDetails?.branchID}`
                                    )}
                                </span>
                            )}
                        </div>
                        </> : <>
                            <div className={appointmentStyles["detailRow"]}>
                                <span className={appointmentStyles["label"]}>Please select a branch on the dashboard to view details.</span>
                            </div>
                        </>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BranchDetailsModal
